export class ConfigurationModel {
  constructor(
    public id?: number,
    public squareMetersPerLinearMeter?: string,
    public defaultCurrency?: string,
    public createdAt?: string
  ) {}

  public fromJSON(json: any): ConfigurationModel {
    if (json) {
      this.id = json.id;
      this.squareMetersPerLinearMeter = json.squareMetersPerLinearMeter.toString() || "";
      this.defaultCurrency = json.defaultCurrency;
      this.createdAt = json.createdAt;
    }
    return this;
  }

  public fromJSONList(json: any): ConfigurationModel[] {
    if (json) {
      return json.map((element: any) => new ConfigurationModel().fromJSON(element));
    }
    return [];
  }

  public toJSON() {
    return {
      id: this.id,
      squareMetersPerLinearMeter: this.squareMetersPerLinearMeter?.toString() || "",
      defaultCurrency: this.defaultCurrency,
      createdAt: this.createdAt,
    };
  }

  public getId() {
    return this.id ?? '';
  }
}
